var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ThermalPrintAdmin',{attrs:{"TP":_vm.TP},on:{"save":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }